// All needed imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { LegalParticularComponent } from './legal-particular-component/legal-particular.component';

@NgModule({
  // Declarate the needed components
  declarations: [
    LegalParticularComponent
  ],
  // Import modules which will be used in this module
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  ],
  // Indicate the modules which will be used in other modules
  exports: [
    LegalParticularComponent
  ]
})
export class Form4Module { }
